var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocki = function SvgLocki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5873"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M8 18.001a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h1V8.995a3 3 0 1 1 6 0v2.006h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1zm6-7V8.995a2 2 0 1 0-4 0v2.006z",
    "data-name": "Union 28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1428"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocki);
export default ForwardRef;